import React from "react";
import PropTypes from "prop-types";
import AddIcon from "@mui/icons-material/Add";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { IconButton } from "@mui/material";
import { cameraService } from "client-app-core";
import { getTranslation } from "orion-components/i18n";

const NestedMenu = ({
	nestedMenuContent,
	closeNestedMenu,
	nestedMenuIsFor,
	cameraId,
	closeMainMenu,
	onAddPreset,
	canCreatePreset,
	isPresetValid
}) => {
	const hasNoExistingPresets = nestedMenuIsFor === "presets" && nestedMenuContent.length === 0;

	const nestedMenuActions = menuItem => {
		switch (nestedMenuIsFor) {
			case "presets": {
				const preset = menuItem.value;
				cameraService.gotoPreset(cameraId, preset, err => {
					if (err) {
						console.log("ERROR", err);
					}
				});
				closeMainMenu();
				closeNestedMenu();
				return null;
			}
			default:
				return;
		}
	};
	return (
		<div
			style={{
				width: 160,
				minHeight: 160,
				maxHeight: 280,
				overflowY: "auto",
				background: "#232223",
				borderRadius: 8,
				boxShadow: "0px 0px 6px #0000009A",
				padding: "8px 0",
				position: "relative",
				zIndex: 1001
			}}
		>
			{nestedMenuIsFor === "presets" && canCreatePreset && (
				<>
					<div
						className="bcc-main-menu"
						onClick={() => {
							onAddPreset && onAddPreset();
							closeMainMenu();
							closeNestedMenu();
						}}
						style={{
							width: "100%",
							display: "flex",
							flexDirection: "row",
							alignItems: "center",
							justifyContent: "flex-end",
							padding: "4px 5px",
							fontSize: 10,
							cursor: "pointer",
							boxSizing: "border-box",
							fontFamily: "Roboto",
							color: "#4DB5F4"
						}}
					>
						<div
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "flex-end",
								gap: 4,
								marginRight: 8,
								overflow: "hidden",
								whiteSpace: "nowrap",
								textOverflow: "ellipsis"
							}}
						>
							<AddIcon sx={{ width: 12, height: 12, color: "#4DB5F4" }} />
							{getTranslation("global.CBComponents.newVideoPlayer.components.mainMenu.savePreset")}
						</div>
					</div>
				</>
			)}
			{!isPresetValid && (
				<div
					style={{
						color: "#FF0000",
						width: "100%",
						padding: "12px 16px",
						fontSize: 10,
						textAlign: "center",
						boxSizing: "border-box",
						fontFamily: "Roboto"
					}}
				>
					{getTranslation("global.CBComponents.newVideoPlayer.components.mainMenu.invalidPreset")}
				</div>
			)}
			{hasNoExistingPresets && isPresetValid && (
				<div
					style={{
						width: "100%",
						padding: "12px 16px",
						fontSize: 10,
						fontFamily: "Roboto",
						color: "#B5B9BE",
						textAlign: "center",
						boxSizing: "border-box"
					}}
				>
					{getTranslation("global.CBComponents.newVideoPlayer.components.mainMenu.noExistingPresetsFound")}
				</div>
			)}
			{nestedMenuContent.map((item, idx) =>
				item === "divider" ? (
					<div
						key={idx}
						style={{
							width: "90%",
							height: 1,
							backgroundColor: "#444",
							margin: "8px auto"
						}}
					></div>
				) : (
					<div
						key={idx}
						className="bcc-main-menu"
						onClick={() => nestedMenuActions(item)}
						style={{
							width: "100%",
							display: "flex",
							flexDirection: "row",
							alignItems: "center",
							justifyContent: "space-between",
							padding: "4px 5px",
							fontSize: 10,
							cursor: "pointer",
							boxSizing: "border-box",
							fontFamily: "Roboto"
						}}
					>
						<div
							style={{
								flex: "1 1 auto",
								display: "flex",
								alignItems: "center",
								marginLeft: 16,
								overflow: "hidden",
								whiteSpace: "nowrap",
								textOverflow: "ellipsis"
							}}
						>
							{item?.label || item?.name || item}
						</div>
					</div>
				)
			)}
			<div
				className="bcc-main-menu"
				onClick={closeNestedMenu}
				style={{
					width: "100%",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					padding: "4px 0",
					cursor: "pointer",
					color: "#4DB5F4",
					fontSize: 10,
					borderTop: "1px solid #444"
				}}
			>
				Back
			</div>
		</div>
	);
};

NestedMenu.propTypes = {
	cameraId: PropTypes.string,
	canCreatePreset: PropTypes.bool,
	onAddPreset: PropTypes.func,
	nestedMenuIsFor: PropTypes.string,
	closeMainMenu: PropTypes.func,
	nestedMenuContent: PropTypes.array.isRequired,
	closeNestedMenu: PropTypes.func.isRequired
};

export default NestedMenu;
